export default (settings, module_name, index) => {
  let custom_css = '';
  custom_css += `
  `;
  return `
    <style>
      ${custom_css}
      .rte #Module-${module_name}--${index} .Module-${module_name}__Left:before {
        background-color: ${settings.accent_color.accent_color};
        opacity: ${settings.accent_color.opacity / 100};
      }
      .rte #Module-${module_name}--${index} .Module-${module_name}__Right:before {
        background-color: ${settings.accent_color.accent_color};
        opacity: ${settings.accent_color.opacity / 100};
      }
      .rte #Module-${module_name}--${index} .Section__container {
        padding-top: ${settings.padding.padding_top || 30}px;
        padding-right: ${settings.padding.padding_right || 50}px;
        padding-bottom: ${settings.padding.padding_bottom || 20}px;
        padding-left: ${settings.padding.padding_left || 20}px;
      }
      @media only screen and (max-width: ${window.theme.breakpoints.tablet - 1}px) {
        .rte #Module-${module_name}--${index} .Section__container {
          padding-top: ${settings['padding--mobile'].padding_top || 20}px;
          padding-right: ${settings['padding--mobile'].padding_right || 30}px;
          padding-bottom: ${settings['padding--mobile'].padding_bottom || 0}px;
          padding-left: ${settings['padding--mobile'].padding_left || 0}px;
        }
      }
    </style>
  `;
};
